/* eslint-disable @typescript-eslint/naming-convention */
import {
  defaultBottegaDetails,
  defaultCityIcons,
  defaultSettings,
} from '@velasca/constants'
import type { Settings } from '@velasca/types'

const isClient = typeof window !== 'undefined'

export const google = isClient ? window.google : undefined
export const $permanent_domain = isClient ? window.$permanent_domain : undefined
export const isWoman = isClient ? window.$targetGender === 'woman' : false
export const productMedia = isClient
  ? (window.productImages ?? undefined)
  : undefined
export const $bottega_blocks = isClient ? (window.bottegaBlocks ?? []) : []
export const $bottega_blocks_2025 = isClient
  ? (window.bottegaBlocks2025 ?? [])
  : []
export const $page_bottega = isClient
  ? (window.bottegaJson ?? defaultBottegaDetails)
  : defaultBottegaDetails
export const $city_icons = isClient
  ? (window.cityIcons ?? defaultCityIcons)
  : defaultCityIcons
export const $settings: Settings = isClient
  ? (window.$settings ?? defaultSettings)
  : defaultSettings
